// extracted by mini-css-extract-plugin
export default {"modalContent":"SellerContactModal_modalContent__VbrNp","formWrapper":"SellerContactModal_formWrapper__tSql0"};